import React, { Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import loadable from "@loadable/component";
import "firebase/auth";

const Profile = loadable(() => import("./Profile"));
const AuthPage = loadable(() => import("../auth/AuthPage.js"));
const Lesson = loadable(() => import("./Lesson/Lesson"));
const Terms = loadable(() => import("./Terms"));
const Overview = loadable(() => import("./Overview/Overview"));
const LayoutSplashScreen = loadable(() => import("../../../_metronic"));
const CreatorsSpace = loadable(() => import("./CreatorsSpace/CreatorsSpace"));
const MyCourses = loadable(() => import("./MyCourses"));
const Achievements = loadable(() => import("./Achievements/Achievements"));
const Tutors = loadable(() => import("./Tutors/Tutors"));
const MyStudents = loadable(() => import("./MyStudents/MyStudents"));
const MeetingComponentPage = loadable(() => import("./MeetingComponent"));
//const ExtensionPage = loadable(() => import("./ExtensionPage/ExtensionPage"));
const Guidelines = loadable(() => import("./Guidelines"));
const ViewCertificate = loadable(() =>
  import("./Lesson/certificate/ViewCertificate")
);
const PatternPage = loadable(() => import("./PatternPage/PatternPage"));
const LinkShortner = loadable(() => import("./LinkShortner/LinkShortner"));
const NewLanding = loadable(() => import("./NewLanding"));
const BlogDetails = loadable(() => import("./BlogDetails"));

export default function HomePage(props) {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route exact path="/" component={NewLanding} />
        <Route path="/auth" component={AuthPage} />
        <Route
          exact
          path="/creatorsSpace/:courseId"
          component={CreatorsSpace}
        />
        <Route
          exact
          path="/certificate/view/:user_id/:courseId"
          component={ViewCertificate}
        />
        <Route exact path={"/blog/:id"} component={BlogDetails} />
        <Route exact path="/pattern/:patternId" component={PatternPage} />
        <Route exact path="/p/:shortLinkId" component={LinkShortner} />
        <Route exact path="/cert/:shortLinkId" component={LinkShortner} />
        <Route
          exact
          path="/course/:courseId/lesson/:lessonId"
          component={Lesson}
        />
        <Route
          exact
          path="/pattern/:patternId/lesson/:lessonId"
          component={Lesson}
        />
        <Route
          exact
          path="/meeting/:meetingId"
          component={MeetingComponentPage}
        />
        {/* //  <Route exact path="/extension/:extensionId" component={ExtensionPage} /> */}
        <Route path="/my-courses" component={MyCourses} />
        <Route path="/patterns-create" component={MyCourses} />
        <Route path="/terms" component={Terms} />
        <Route path="/overview" component={Overview} />
        <Route path="/profile" component={Profile} />
        <Route path="/mentoring" component={MyStudents} />
        <Route path="/tutor" component={Tutors} />
        <Route path="/achievements" component={Achievements} />
        <Route path="/guidelines" component={Guidelines} />
        <Redirect to="/error/error-v1" />
      </Switch>
    </Suspense>
  );
}
